<template>
  <div>
    <v-card class="info-card">
      <v-card-text>
        <v-container class="pa-0" fluid>
          <v-row>
            <v-col cols="9">
              <h3 class="info-title">{{ title }}</h3>

              <p class="info-description">{{ description }}</p>
            </v-col>
            <v-col cols="3">
              <p class="status">
                <mf-icon fill small :color="statusColor">fiber_manual_record</mf-icon><span>{{ formatedStatus }}</span>
              </p>
            </v-col>
          </v-row>
        </v-container>

        <v-container class="pa-0" fluid>
          <v-row>
            <v-col cols="4">
              <h3 class="info-header">Data e hora de envio</h3>
              <p class="info-description">{{ DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat('dd/MM/yyyy') }} - {{ time }}</p>
            </v-col>
            <v-col cols="4">
              <h3 class="info-header">Periodo de mensuração</h3>
              <p class="info-description">
                {{ DateTime.fromFormat(initialDate, 'yyyy-MM-dd').toFormat('dd/MM/yyyy') }} -
                {{ DateTime.fromFormat(finalDate, 'yyyy-MM-dd').toFormat('dd/MM/yyyy') }}
              </p>
            </v-col>
            <v-col cols="4">
              <h3 class="info-header">Frequência de envio</h3>
              <p class="info-description">
                <span v-if="frequency.type === 'ONETIME'">Disparo único</span>
                <span v-if="frequency.type === 'RECURRENT'">Recorrente a cada {{ frequency.interval }} {{ frequency.interval !== 1 ? 'dias' : 'dia' }}</span>
              </p>
            </v-col>
          </v-row>
        </v-container>

        <v-container class="pa-0" fluid>
          <v-row>
            <v-col v-if="segments && segments.length">
              <h3 class="info-segments">Segmentos</h3>
              <v-chip-group show-arrows active-class="primary--text">
                <v-chip v-for="(segment, index) in segments" :key="index" small :ripple="false">
                  <span v-if="segment"
                    ><b>{{ segment.name }}</b
                    >{{ segment.clients_qty_at_campaign !== null ? ` (${localeString(segment.clients_qty_at_campaign)} clientes)` : '' }}</span
                  >
                </v-chip>
              </v-chip-group>
            </v-col>
            <v-col v-if="products && products.length">
              <h3 class="info-products">Produtos</h3>
              <v-chip-group show-arrows active-class="primary--text">
                <v-chip v-for="(product, index) in products" :key="index" small :ripple="false">
                  <span>{{ product.sku }} - {{ product.name }}</span>
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { localeString } from '@/config/helpers.js'

export default {
  props: {
    title: String,
    description: String,
    date: String,
    time: String,
    segments: Array,
    products: Array,
    initialDate: String,
    finalDate: String,
    status: String,
    frequency: Object,
  },
  data: () => ({
    DateTime: DateTime,
  }),
  computed: {
    formatedStatus() {
      if (!this.status) return '-'
      switch (this.status) {
        case 'DRAFT':
          return 'RASCUNHO'
        case 'SCHEDULED':
          return 'AGENDADA'
        case 'FINISHED':
          return 'CONCLUÍDA'
        case 'ACTIVE':
          return 'ATIVA'
        case 'EXPIRED':
          return 'EXPIRADA'
        default:
          return this.status
      }
    },

    statusColor() {
      if (!this.status) return
      switch (this.status?.toUpperCase()) {
        case 'FINISHED':
          return '#2b67e5'
        case 'ACTIVE':
          return '#77E56D'
        case 'SCHEDULED':
          return '#ffe336'
        case 'EXPIRED':
          return '#F15435'
        default:
          return '#BFBFBF'
      }
    },
  },
  methods: {
    localeString,
  },
}
</script>

<style lang="scss">
.status {
  padding-bottom: 4px;
  span {
    font-size: 12px;
    letter-spacing: 0.2px;
  }
}
.info-card {
  .info-title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0.33px;
    margin-bottom: 8px;
    color: $cinza-d20;
  }
  .info-description {
    font-size: 14px;
    letter-spacing: 0.23px;
    color: $cinza-d10;
    margin-bottom: 0;
  }
  .info-date,
  .info-time,
  .info-segments,
  .info-products {
    font-size: 18px;
    letter-spacing: 0.33px;
    margin-bottom: 8px;
    color: $cinza-d20;
  }

  .date-box,
  .time-box {
    width: fit-content;
    padding: 2px 12px;
    border-radius: 16px;
    background-color: $cinza-l70;
    font-size: 14px;
    letter-spacing: 0.23px;
    text-align: center;
    color: $cinza-d20;
  }
}
</style>
